// Thin adapter. The implementation now lives in @intrasync/stores
// (specialized/PerformanceStore); this file exists only to preserve the local
// import path 'stores/PerformanceStore', the local named export, and the local
// RootStore constructor type.
//
// Why a cast and not `class PerformanceStore extends LibPerformanceStore`:
// the library store calls makeAutoObservable(this) in its constructor, and MobX
// throws ("can only be used for classes that don't have a superclass") when the
// instance's prototype chain has one. A subclass shim would crash at startup.
//
// Why the bare '@intrasync/stores' specifier: tsconfig.json sets
// "moduleResolution": "Node", which ignores the package `exports` map, so the
// '@intrasync/stores/specialized/...' subpaths do not resolve for TypeScript.
// The root barrel re-exports PerformanceStore, so this resolves.
import { PerformanceStore as LibPerformanceStore } from '@intrasync/stores';
import type RootStore from './RootStore';

/**
 * The library types its stores against ITS OWN RootStore, which declares
 * `private` members and is therefore nominal to TypeScript. This app mounts its
 * local RootStore, which is structurally compatible at runtime (the store only
 * reads rootStore.notificationStore). Re-type the constructor here so no call
 * site has to cast.
 */
type PerformanceStoreConstructor = new (
  rootStore: RootStore
) => LibPerformanceStore;

export const PerformanceStore =
  LibPerformanceStore as unknown as PerformanceStoreConstructor;
export type PerformanceStore = LibPerformanceStore;
